import React from 'react'
import { connect } from 'react-redux'

import { actions as ConfigActions } from 'data/config'

function useRefreshedSearchTokenRefresh(refreshToken, extraRefreshDep = null) {
  const fetching = React.useRef()
  const refreshTokenIfNeeded = React.useCallback(
    async () => {
      if (fetching.current) {
        return
      }
      try {
        fetching.current = true
        await refreshToken()
        fetching.current = false
      } catch (error) {
        fetching.current = false
      }
    },
    [refreshToken]
  )

  // refresh on mount and deps change
  React.useEffect(
    () => {
      refreshTokenIfNeeded()
    },
    [refreshTokenIfNeeded, extraRefreshDep]
  )
  // refresh on online status change
  React.useEffect(
    () => {
      window.addEventListener('online', refreshTokenIfNeeded)
      return () => window.removeEventListener('online', refreshTokenIfNeeded)
    },
    [refreshTokenIfNeeded]
  )
}

export default function(getExtraDepsFromProps = () => []) {
  return function fetchesSearchToken(OriginalComponent) {
    return connect(
      null,
      { fetchSearchToken: ConfigActions.fetchSearchToken }
    )(({ fetchSearchToken, ...props }) => {
      useRefreshedSearchTokenRefresh(
        fetchSearchToken,
        getExtraDepsFromProps(props)
      )
      return <OriginalComponent {...props} />
    })
  }
}
